'use client';

import { useCallback, useState } from 'react';
import { useProjectNameFragment } from '@frameio/graphql-client/generated';
import { useOpenOnDesktopDialogContext } from '@frameio/shared/contexts/ModalContext';
import { AppDownloadDialog } from '@frameio/shared/resources/mounted-storage';
import { OpenOnDesktopDialog } from './OpenOnDesktopDialog';

/** <OpenOnDesktopDialogs component contains the dialogs appearing when a deep link to a project or an asset is opened
 * @example
 * ```
    const { open } = useOpenOnDesktopDialogContext();
    ...
    window.location.href = `frameio-drive://open-asset?projectId=${projectId}&accountId=${accountId}&assetId=${assetId}`;
    open({ projectId, assetId });
 * ```
 */
export function OpenOnDesktopDialogs() {
  const { isOpen, projectId, close } = useOpenOnDesktopDialogContext();
  const projectName = useProjectNameFragment(projectId)?.data?.name ?? '';
  const [isAppDownloadOpen, setIsAppDownloadOpen] = useState(false);

  const handleCloseDialog = useCallback(() => {
    close();
    setIsAppDownloadOpen(false);
  }, [close]);

  const handleOpenAppDownload = useCallback(() => {
    setIsAppDownloadOpen(true);
  }, []);

  return (
    <>
      <OpenOnDesktopDialog
        isShowing={isOpen}
        onClose={handleCloseDialog}
        onOpenAppDownload={handleOpenAppDownload}
        projectName={projectName}
      />
      <AppDownloadDialog
        isShowing={isAppDownloadOpen}
        onClose={handleCloseDialog}
        projectId={projectId}
        trackingSource="finder_menu_bar"
      />
    </>
  );
}
